export default __webpack_public_path__ + "static/media/image-board-study-pyramid-n-m@2x.c19fa742.png";